import { DrawerMode } from '@billy/design-system'
import { useMemo } from 'react'

import { AttachmentFilterType } from '@features/attachments/enums/attachmentFiltertype'
import { AttachmentsSortProperty } from '@features/attachments/enums/attachmentsSortProperty'
import { AttachmentFilters } from '@features/attachments/types/attachmentFilters'

import { SortDirection } from '../../../enums/sortDirection'
import { useSimpleQueryParams } from './useSimpleQueryParams'

type UseAttachmentsFiltersResponse = [AttachmentFilters, (filters: Partial<AttachmentFilters>) => void]

export const defaultAttachmentsQuery: AttachmentFilters = {
  page: 1,
  searchQuery: undefined,
  drawerMode: DrawerMode.Closed,
  sortBy: AttachmentsSortProperty.CreatedTime,
  sortDirection: SortDirection.Desc,
  type: AttachmentFilterType.All,
}

export const useAttachmentsFilters = (
  {
    defaultType,
    setDefaultQuery,
  }: {
    defaultType: AttachmentFilterType
    setDefaultQuery: boolean
  } = {
    defaultType: AttachmentFilterType.All,
    setDefaultQuery: false,
  },
): UseAttachmentsFiltersResponse => {
  const [queryParams, setQueryParams] = useSimpleQueryParams({
    setDefaultQuery,
    defaultQuery: {
      ...defaultAttachmentsQuery,
      type: defaultType,
    },
  })

  return useMemo(() => {
    return [
      {
        ...queryParams,
        // Sometimes `page` comes as a string. It needs to be always `number` type.
        page: Number(queryParams.page),
      },
      setQueryParams,
    ]
  }, [queryParams, setQueryParams])
}
